import { corpayTermsAndConditions } from '../constants/corpaylodging/corpayTermsAndConditions';
import { Injectable } from '@angular/core';
import { BrandingAccess } from '@rx-applications/shared/branding/utils';
import { Appearance } from '@stripe/stripe-js';
import { supportedLanguagesCorpaylodging } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { corpaylodgingStripeAppearance } from '../constants/corpaylodging-stripe-appearance';

@Injectable({
  providedIn: 'root',
})
export class CorpayLodgingBrandingAccessService implements BrandingAccess {
  getMetaTagColor(): string {
    return '#be1549'; // $color-corpay-red-main-dark
  }
  getFavicon(): string {
    return '/assets/images/favicon_corpaylodging.png';
  }

  getNoDataImagePath(): string {
    return '/assets/images/empty-data-corpaylodging.png';
  }

  getLogoFullUrl(): string {
    return './assets/images/logos/logo_full_corpaylodging.svg';
  }

  getLogoHeightInPx(): number {
    return 32;
  }

  invoicelogoImagePlacing(): number[] {
    return [380, 16, 0, 195, 25];
  }

  getInvoiceLogoUrl(): string {
    return '/assets/images/logos/logo_full_corpaylodging.svg';
  }

  getPieChartColours() {
    return ['#E7004C', '#00B5E2', '#6F42C1', '#DC3545', '#FFB100', '#198754'];
  }

  getStripeAppearance(): Appearance {
    return corpaylodgingStripeAppearance;
  }

  getDefaultTitle(): string {
    return 'Corpay Lodging';
  }

  getTranslationPath(): string {
    return '/corpaylodging';
  }

  getTheme(): string {
    return 'corpaylodging';
  }

  getTermsAndConditions(): string {
    return corpayTermsAndConditions;
  }

  getHotelLocationPinUrl(): string {
    return '/assets/images/map/hotel_location_corpaylodging.svg';
  }

  getPriceActivePinUrl(): string {
    return '/assets/images/map/price-pin-active-corpaylodging.svg';
  }

  getPricePinUrl(): string {
    return '/assets/images/map/price-pin-corpaylodging.svg';
  }

  getEmailSupportContact(): string {
    return 'support@corpay-lodging.com';
  }

  getContactName(): string {
    return 'Corpay Lodging USA';
  }

  shouldDisplayContact(): boolean {
    return false;
  }

  getSupportedLanguages() {
    return supportedLanguagesCorpaylodging;
  }

  shouldShowIosModal() {
    return false;
  }

  getErrorPageSupportEmail(): string {
    return "support@corpay-lodging.com";
  }
}
